export default (function () {
  return {
    defaultColumnCount: 5,
    gridGap: undefined,
    padding: undefined
  };
});